export default "__VITE_ASSET__e2018d55__"